import * as React from 'react';

import { useNewPdDesignEnabled } from '../../hooks/useNewPdDesignEnabled';

import { Container, Description, MarginWrapper } from './styled';

export interface IAboutBrandProps {
  description?: string;
}

export const AboutBrand: React.FC<IAboutBrandProps> = React.memo(
  ({ description }) => {
    const newPdDesignEnabled = useNewPdDesignEnabled();

    if (!description) {
      return null;
    }
    return (
      <Container id="pdAboutBrand" newDesign={newPdDesignEnabled}>
        <MarginWrapper>
          <Description
            dangerouslySetInnerHTML={{ __html: description }}
            newPdDesignEnabled={newPdDesignEnabled}
          />
        </MarginWrapper>
      </Container>
    );
  }
);
